module.exports = __webpack_public_path__ + "static/img-test-izqa-551a8a49cc5d914bde6afc37126ef180.jpg";